import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { TransactionService } from "appworks/services/transaction/transaction-service";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";

export function updateFieldsAfterFreespins(): void {
    const gameplay = gameState.getCurrentGame();

    uiFlags.set(UIFlag.FREE_SPINS, false);
    uiFlags.set(UIFlag.PROMPT, false);

    Services.get(TransactionService).setBalance(gameState.getCurrentGame().balance);
    // const temp = gameplay.getTotalWin();
    // Services.get(TransactionService).setWinnings(temp).execute();

    // TOOD: Should be set via UI flags
    // Components.get(BetBarComponent).setType(BetBarType.DEFAULT);
}
